export const CONTACT_EMAIL = 'galiastandardpoodles@gmail.com';

export const SOCIAL_LINKS = {
    facebook: 'https://www.facebook.com/galiastandardpoodles',
    instagram: 'https://www.instagram.com/galiastandardpoodles',
    tiktok: 'https://www.tiktok.com/@galiapoodles',
} as const;

export const SOCIAL_MAILTO = `mailto:${CONTACT_EMAIL}`;

/** Profile URLs for schema.org sameAs and social icons. */
export const SOCIAL_PROFILE_URLS = [
    SOCIAL_LINKS.facebook,
    SOCIAL_LINKS.instagram,
    SOCIAL_LINKS.tiktok,
] as const;

export const LOCATION_LABEL = 'Austin, TX';
